export const resetCustomerProfile = () => {
  try {
    if (window.salja?.customerProfile?.resetCustomerProfile) {
      window.salja.customerProfile.resetCustomerProfile();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to reset Customer Profile:", error);
  }
  return null;
};
